import { apiFetchWeb } from "@/hooks/apiFetchWeb"

type ProductFilters = {
  tag_id?: number
  category_id?: number[]
  search?: string
  per_page?: number
  page?: number
  size_id?: number[]
  color_id?: number[]
}

export const websiteProductService = {
  getProducts: async (filters: ProductFilters = {}, signal?: AbortSignal) => {
    const params = new URLSearchParams()
    if (filters.tag_id) params.append("tag_id", filters.tag_id.toString())
    filters.category_id?.forEach((id) =>
      params.append("category_id[]", id.toString())
    )
    if (filters.search) params.append("search", filters.search)
    if (filters.per_page) params.append("per_page", filters.per_page.toString())
    if (filters.page) params.append("page", filters.page.toString())

    if (filters.size_id && filters.size_id.length > 0) {
      filters.size_id.forEach((id) => params.append("size_id[]", id.toString()))
    }
    if (filters.color_id && filters.color_id.length > 0) {
      filters.color_id.forEach((id) =>
        params.append("color_id[]", id.toString())
      )
    }

    const queryString = params.toString()
    return apiFetchWeb(
      `website/products${queryString ? `?${queryString}` : ""}`,
      {
        signal,
      }
    )
  },
  getProductGroups: async (
    filters: ProductFilters = {},
    signal?: AbortSignal
  ) => {
    const params = new URLSearchParams()
    if (filters.tag_id) params.append("tag_id", filters.tag_id.toString())
    filters.category_id?.forEach((id) =>
      params.append("category_id[]", id.toString())
    )
    if (filters.search) params.append("search", filters.search)
    if (filters.per_page) params.append("per_page", filters.per_page.toString())
    if (filters.page) params.append("page", filters.page.toString())

    if (filters.size_id && filters.size_id.length > 0) {
      filters.size_id.forEach((id) => params.append("size_id[]", id.toString()))
    }
    if (filters.color_id && filters.color_id.length > 0) {
      filters.color_id.forEach((id) =>
        params.append("color_id[]", id.toString())
      )
    }

    const queryString = params.toString()
    return apiFetchWeb(
      `website/product-groups${queryString ? `?${queryString}` : ""}`,
      {
        signal,
      }
    )
  },
  getProductGroup: async (sku: string, signal?: AbortSignal) =>
    apiFetchWeb(`website/product-groups/${sku}`, {
      signal,
    }),
  getProduct: async (id: number, signal?: AbortSignal) =>
    apiFetchWeb(`website/products/${id}`, {
      signal,
    }),
  getSimilarProducts: async (sku: string, signal?: AbortSignal) =>
    apiFetchWeb(`website/product-groups/${sku}/similar`, {
      signal,
    }),
}
